// class TsProgress extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//   }

//   async renderProgress() {
//     if (!document.querySelector('.cart-drawer-modal').classList.contains('second')) return;
//     const cartResponse = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer`);
//     const cartData = await cartResponse.json();

//     const tempDiv = document.createElement('div');
//     tempDiv.innerHTML = cartData['cart-drawer'];

//     const newUpsell = tempDiv.querySelector('[data-progress]');
//     const oldUpsell = document.querySelector('[data-progress]');

//     if (newUpsell && oldUpsell) {
//       oldUpsell.innerHTML = newUpsell.innerHTML;
//     }
//   }

//   handleProgress() {
//     window.setTimeout(() => {
//       this.handleAddToCart();
//     }, 1000)
//   }

//   saveRemovedItem(variantId) {
//     let removedItems = JSON.parse(sessionStorage.getItem("removed_upsell_items")) || [];

//     if (!removedItems.includes(variantId)) {
//       removedItems.push(variantId);
//       sessionStorage.setItem("removed_upsell_items", JSON.stringify(removedItems));
//     }
//   }

//   restoreRemovedItem(variantId) {
//     let removedItems = JSON.parse(sessionStorage.getItem("removed_upsell_items")) || [];
//     removedItems = removedItems.filter(id => id !== variantId);
//     sessionStorage.setItem("removed_upsell_items", JSON.stringify(removedItems));
//   }


//   async handleAddToCart() {
//     if (!document.querySelector('.cart-drawer-modal').classList.contains('second')) return;
//     const steps = this.querySelectorAll('.step');

//     const stepData = Array.from(steps)
//       .map(step => ({
//         id: step.dataset.id?.trim(),
//         threshold: Number(step.dataset.trashold) || 0
//       }))
//       .filter(step => step.id);

//     fetch(`${window.Shopify.routes.root}cart.js`)
//       .then(res => res.json())
//       .then(cart => {
//         const cartItems = cart.items;

//         const progressItems = cartItems.filter(item => item.properties?._added_by === "progress_bar");

//         const progressItemsTotal = progressItems.reduce((sum, item) => sum + item.final_line_price, 0);
//         const baseTotal = cart.total_price - progressItemsTotal;

//         const itemsToAdd = [];
//         const itemsToRemove = [];

//         stepData.forEach(step => {

//           const progressItem = progressItems.find(item => item.id.toString() === step.id);
//           const removedItems = JSON.parse(sessionStorage.getItem("removed_upsell_items")) || [];

//           if (baseTotal >= step.threshold) {
//             if (!progressItem && !removedItems.includes(step.id)) {
//               itemsToAdd.push({
//                 id: Number(step.id),
//                 quantity: 1,
//                 properties: { _added_by: "progress_bar" }
//               });
//               this.saveRemovedItem(step.id);
//             }
//           } else {

//             if (progressItem) {
//               itemsToRemove.push(progressItem.key);
//               this.restoreRemovedItem(step.id);
//             }
//           }
//         });

//         const actions = [];

//         if (itemsToAdd.length > 0) {
//           actions.push(fetch(`${window.Shopify.routes.root}cart/add.js`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ items: itemsToAdd })
//           }));
//         }

//         if (itemsToRemove.length > 0) {
//           actions.push(fetch(`${window.Shopify.routes.root}cart/update.js`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               updates: Object.fromEntries(itemsToRemove.map(key => [key, 0]))
//             })
//           }));
//         }

//         return Promise.all(actions);
//       })
//       .then(() => {
//         theme.addedToCartHandler()
//         this.renderProgress();
//       })
//       .catch(console.error);

//   }

//   disconnectedCallback() {
//   }
// }

// customElements.define('ts-progress', TsProgress);

class TsProgress extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
  }

  async renderProgress() {
    if (!document.querySelector('.cart-drawer-modal').classList.contains('second')) return;
    const cartResponse = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer`);
    const cartData = await cartResponse.json();

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = cartData['cart-drawer'];

    const newUpsell = tempDiv.querySelector('[data-progress]');
    const oldUpsell = document.querySelector('[data-progress]');

    if (newUpsell && oldUpsell) {
      oldUpsell.innerHTML = newUpsell.innerHTML;
    }
  }

  handleProgress() {
    window.setTimeout(() => {
      this.handleAddToCart();
    }, 1000)
  }

  saveRemovedItem(variantId) {
    let removedItems = JSON.parse(sessionStorage.getItem("removed_upsell_items")) || [];

    if (!removedItems.includes(variantId)) {
      removedItems.push(variantId);
      sessionStorage.setItem("removed_upsell_items", JSON.stringify(removedItems));
    }
  }

  restoreRemovedItem(variantId) {
    let removedItems = JSON.parse(sessionStorage.getItem("removed_upsell_items")) || [];
    removedItems = removedItems.filter(id => id !== variantId);
    sessionStorage.setItem("removed_upsell_items", JSON.stringify(removedItems));
  }


  async handleAddToCart() {

    if (!document.querySelector('.cart-drawer-modal').classList.contains('second')) return;
    const steps = this.querySelectorAll('.step');
    const stepData = Array.from(steps)
      .map(step => ({
        id: step.dataset.id?.trim(),
        threshold: Number(step.dataset.trashold) || 0
      }))
      .filter(step => step.id);

    fetch(`${window.Shopify.routes.root}cart.js`)
      .then(res => res.json())
      .then(cart => {
        const cartItems = cart.items;

        const progressBar = document.querySelector('.progress-bar');
        if (progressBar) {
          if (cartItems.length === 0) {
            progressBar.style.display = 'none';
          } else {
            progressBar.style.display = 'block';
          }
        }

        const progressItems = cartItems.filter(item => item.properties?._added_by === "progress_bar");

        const progressItemsTotal = progressItems.reduce((sum, item) => sum + item.final_line_price, 0);
        const baseTotal = cart.total_price - progressItemsTotal;

        /* Start Code */
        setTimeout(function() {
          var element = document.querySelector('.progress-bar__bar .step:nth-child(5)');
          if (element) {
              var style = element.getAttribute('style'); // e.g. "--var-percent:100%"
              var match = style.match(/--var-percent:\s*(\d+)/);
              if (match) {
                  var percentValue = parseInt(match[1], 10); // Extracts 100 as a number
                  console.log(percentValue); // 100
                if(percentValue < 100) {
                  var percentValue = parseInt(match[1], 10); // Extracts 100
                  var result = percentValue - 22; // Subtracts 20
                  console.log(result); // e.g. 80
                  element.setAttribute('style', `--var-percent:${result}%`);
                } else {
                  console.log("more");
                }
              }
          } else {
              console.log('Element not found');
          }
      }, 2500);
        /* End Code */

        const itemsToAdd = [];
        const itemsToRemove = [];
        stepData.forEach(step => {

          const progressItem = progressItems.find(item => item.id.toString() === step.id);
          const removedItems = JSON.parse(sessionStorage.getItem("removed_upsell_items")) || [];
          console.log("base",baseTotal)
          console.log("step",step.threshold)
          console.log("progress",progressItem)
          if (baseTotal >= step.threshold) {
            if (!progressItem && !removedItems.includes(step.id)) {
              itemsToAdd.push({
                id: Number(step.id),
                quantity: 1,
                properties: { _added_by: "progress_bar" }
              });
              this.saveRemovedItem(step.id);
            }
          } else {

            if (progressItem) {
              itemsToRemove.push(progressItem.key);
              this.restoreRemovedItem(step.id);
            }
          }
        });
        console.log('Items to add:', itemsToAdd);
        const actions = [];

        if (itemsToAdd.length > 0) {
          actions.push(fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: itemsToAdd })
          }));
        }

        if (itemsToRemove.length > 0) {
          actions.push(fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              updates: Object.fromEntries(itemsToRemove.map(key => [key, 0]))
            })
          }));
        }
        return Promise.all(actions);
      })

      .then(() => {
        theme.addedToCartHandler()
        this.renderProgress();
      })
      .catch(console.error);

  }

  disconnectedCallback() {
  }
}

customElements.define('ts-progress', TsProgress);

window.onload = function() {
var element = document.querySelector('.progress-bar__bar .step:nth-child(5)');
  if (element) {
      var style = element.getAttribute('style'); // e.g. "--var-percent:100%"
      var match = style.match(/--var-percent:\s*(\d+)/);
      if (match) {
          var percentValue = parseInt(match[1], 10); // Extracts 100 as a number
          console.log(percentValue); // 100
        if(percentValue < 100) {
          var percentValue = parseInt(match[1], 10); // Extracts 100
          var result = percentValue - 22; // Subtracts 20
          console.log(result); // e.g. 80
          element.setAttribute('style', `--var-percent:${result}%`);
        } else {
          console.log("more");
        }
      }
  } else {
      console.log('Element not found');
  }
}